export type GigyaUserRecord = {
	profileSchema: {
		education: {
			startYear?: number | number[];
			school?: string | string[];
			schoolType?: string | string[];
			fieldOfStudy?: string | string[];
			endYear?: number | number[];
			degree?: string | string[];
		} | Array<{
			startYear?: number | number[];
			school?: string | string[];
			schoolType?: string | string[];
			fieldOfStudy?: string | string[];
			endYear?: number | number[];
			degree?: string | string[];
		}>;
		favorites: {
			books: {
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			} | Array<{
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			}>;
			music: {
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			} | Array<{
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			}>;
			activities: {
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			} | Array<{
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			}>;
			movies: {
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			} | Array<{
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			}>;
			television: {
				name?: string | string[];
				id?: string | string[];
				category?: string | string[];
			} | Array<{
				name?: string | string[];
				id?: string | string[];
				category?: string | string[];
			}>;
			interests: {
				category?: string | string[];
				id?: string | string[];
				name?: string | string[];
			} | Array<{
				category?: string | string[];
				id?: string | string[];
				name?: string | string[];
			}>;
		} | Array<{
			books: {
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			} | Array<{
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			}>;
			music: {
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			} | Array<{
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			}>;
			activities: {
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			} | Array<{
				category?: string | string[];
				name?: string | string[];
				id?: string | string[];
			}>;
			movies: {
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			} | Array<{
				name?: string | string[];
				category?: string | string[];
				id?: string | string[];
			}>;
			television: {
				name?: string | string[];
				id?: string | string[];
				category?: string | string[];
			} | Array<{
				name?: string | string[];
				id?: string | string[];
				category?: string | string[];
			}>;
			interests: {
				category?: string | string[];
				id?: string | string[];
				name?: string | string[];
			} | Array<{
				category?: string | string[];
				id?: string | string[];
				name?: string | string[];
			}>;
		}>;
		photoURL?: string | string[];
		professionalHeadline?: string | string[];
		email: string | string[];
		lastLoginLocation: {
			city?: string | string[];
			country?: string | string[];
			coordinates: {
				lat?: number | number[];
				lon?: number | number[];
			} | Array<{
				lat?: number | number[];
				lon?: number | number[];
			}>;
			state?: string | string[];
		} | Array<{
			city?: string | string[];
			country?: string | string[];
			coordinates: {
				lat?: number | number[];
				lon?: number | number[];
			} | Array<{
				lat?: number | number[];
				lon?: number | number[];
			}>;
			state?: string | string[];
		}>;
		oidcData: {
			address: {
				locality?: string | string[];
				formatted?: string | string[];
				country?: string | string[];
				street_address?: string | string[];
				region?: string | string[];
				postal_code?: string | string[];
			} | Array<{
				locality?: string | string[];
				formatted?: string | string[];
				country?: string | string[];
				street_address?: string | string[];
				region?: string | string[];
				postal_code?: string | string[];
			}>;
			website?: string | string[];
			updated_at?: string | string[];
			name?: string | string[];
			email_verified?: string | string[];
			middle_name?: string | string[];
			phone_number_verified?: string | string[];
			zoneinfo?: string | string[];
			phone_number?: string | string[];
			locale?: string | string[];
		} | Array<{
			address: {
				locality?: string | string[];
				formatted?: string | string[];
				country?: string | string[];
				street_address?: string | string[];
				region?: string | string[];
				postal_code?: string | string[];
			} | Array<{
				locality?: string | string[];
				formatted?: string | string[];
				country?: string | string[];
				street_address?: string | string[];
				region?: string | string[];
				postal_code?: string | string[];
			}>;
			website?: string | string[];
			updated_at?: string | string[];
			name?: string | string[];
			email_verified?: string | string[];
			middle_name?: string | string[];
			phone_number_verified?: string | string[];
			zoneinfo?: string | string[];
			phone_number?: string | string[];
			locale?: string | string[];
		}>;
		politicalView?: string | string[];
		certifications: {
			number?: string | string[];
			authority?: string | string[];
			endDate?: Date | Date[];
			name?: string | string[];
			startDate?: Date | Date[];
		} | Array<{
			number?: string | string[];
			authority?: string | string[];
			endDate?: Date | Date[];
			name?: string | string[];
			startDate?: Date | Date[];
		}>;
		skills: {
			skill?: string | string[];
			years?: number | number[];
			level?: string | string[];
		} | Array<{
			skill?: string | string[];
			years?: number | number[];
			level?: string | string[];
		}>;
		educationLevel?: string | string[];
		religion?: string | string[];
		likes: {
			timestamp?: number | number[];
			name?: string | string[];
			id?: string | string[];
			time?: Date | Date[];
			category?: string | string[];
		} | Array<{
			timestamp?: number | number[];
			name?: string | string[];
			id?: string | string[];
			time?: Date | Date[];
			category?: string | string[];
		}>;
		birthYear?: number | number[];
		timezone?: string | string[];
		phones: {
			type?: string | string[];
			number?: string | string[];
			default?: string | string[];
		} | Array<{
			type?: string | string[];
			number?: string | string[];
			default?: string | string[];
		}>;
		patents: {
			date?: Date | Date[];
			url?: string | string[];
			office?: string | string[];
			summary?: string | string[];
			status?: string | string[];
			number?: string | string[];
			title?: string | string[];
		} | Array<{
			date?: Date | Date[];
			url?: string | string[];
			office?: string | string[];
			summary?: string | string[];
			status?: string | string[];
			number?: string | string[];
			title?: string | string[];
		}>;
		languages?: string | string[];
		work: {
			startDate?: Date | Date[];
			endDate?: Date | Date[];
			description?: string | string[];
			company?: string | string[];
			companyID?: string | string[];
			title?: string | string[];
			industry?: string | string[];
			companySize?: number | number[];
			isCurrent?: boolean | boolean[];
			location?: string | string[];
		} | Array<{
			startDate?: Date | Date[];
			endDate?: Date | Date[];
			description?: string | string[];
			company?: string | string[];
			companyID?: string | string[];
			title?: string | string[];
			industry?: string | string[];
			companySize?: number | number[];
			isCurrent?: boolean | boolean[];
			location?: string | string[];
		}>;
		publications: {
			title?: string | string[];
			summary?: string | string[];
			publisher?: string | string[];
			url?: string | string[];
			date?: Date | Date[];
		} | Array<{
			title?: string | string[];
			summary?: string | string[];
			publisher?: string | string[];
			url?: string | string[];
			date?: Date | Date[];
		}>;
		industry?: string | string[];
		firstName?: string | string[];
		address?: string | string[];
		proxyemail?: string | string[];
		city?: string | string[];
		followingCount?: number | number[];
		profileURL?: string | string[];
		thumbnailURL?: string | string[];
		verified?: string | string[];
		specialities?: string | string[];
		gender?: string | string[];
		hometown?: string | string[];
		interestedIn?: string | string[];
		birthMonth?: number | number[];
		followersCount?: number | number[];
		birthDay?: number | number[];
		interests?: string | string[];
		lastName?: string | string[];
		locale?: string | string[];
		relationshipStatus?: string | string[];
		name?: string | string[];
		nickname?: string | string[];
		honors?: string | string[];
		age?: number | number[];
		bio?: string | string[];
		state?: string | string[];
		username?: string | string[];
		zip?: string | string[];
		country?: string | string[];
		activities?: string | string[];
	};
	dataSchema: {
		practiceAddressLine1?: string | string[];
		practiceAddressLine2?: string | string[];
		primaryPhoneNumber?: string | string[];
		roleCode?: string | string[];
		currentSchooName?: string | string[];
		hillsAccountNumber?: string | string[];
		isGovernmentOfficial?: boolean | boolean[];
		roleId?: string | string[];
		isGSFUser?: boolean | boolean[];
		mobileNumber?: string | string[];
		titleCode?: string | string[];
		contactPersonNumberCRM?: string | string[];
		practiceCity?: string | string[];
		isCLPUser?: boolean | boolean[];
		beginYearStudy?: string | string[];
		currentSchoolName?: string | string[];
		isHroCommerceAccountActive?: boolean | boolean[];
		invoiceNumber?: string | string[];
		contactPersonNumberERP?: string | string[];
		SF_PreferedShipTo?: string | string[];
		countryCode_ISO?: string | string[];
		practicePostalCode?: string | string[];
		SF_StoreSoldTo?: string | string[];
		primaryFaxNumber?: string | string[];
		salesOrg?: string | string[];
		qualificationCode?: string | string[];
		locale?: string | string[];
		countryCode?: string | string[];
		HRO_PreferedShipTo?: string | string[];
		country?: string | string[];
		practiceName?: string | string[];
		roleType?: string | string[];
		hmAccountNumber?: number | number[];
		Vet_Pro_Check?: boolean | boolean[];
		graduationYear?: string | string[];
	};
	subscriptionsSchema: {
		HRO_Subscription?: undefined;
		hillsPhoneOptIn?: undefined;
		eucrmOptIn: {
			email?: undefined;
		};
		euOptIn?: undefined;
		euPhoneOptIn?: undefined;
	};
	preferencesSchema: {
		terms: {
			hills4meTerms?: undefined;
			hillsTermsOfUse: undefined;
			hillsWebshopTermsOfUse?: undefined;
			hillsGSFTermsOfUse: undefined;
		};
		privacy: {
			hillsPrivacyPolicy: undefined;
		};
	};
};

export enum GigyaGroupModels {
	ClinicModel = 'ClinicModelEUNL',
}

export type GigyaGroupSchemas = {
	ClinicModelEUNL: {
		relationshipDataSchema: {
			role?: string | string[];
			comment?: string | string[];
			status?: string | string[];
			permissions?: string | string[];
			nickname?: string | string[];
		};
		groupDataSchema: {
			streetAddress: string | string[];
			billTo?: string | string[];
			softClosed?: boolean | boolean[];
			blockedClinic?: boolean | boolean[];
			billingCity?: string | string[];
			shipTo?: string | string[];
			isStaffFeedingClinic?: boolean | boolean[];
			salesOrg?: string | string[];
			clinicFullName?: string | string[];
			archived?: boolean | boolean[];
			removedUsers?: string | string[];
			zip: string | string[];
			customerPlanGroup?: string | string[];
			city: string | string[];
			soldToClinicName?: string | string[];
			clinicType?: string | string[];
			customerGroup?: string | string[];
			approvedEmails?: string | string[];
			salesZone?: string | string[];
			salesRegion?: string | string[];
			priceGroup?: string | string[];
			industry?: string | string[];
			clinicName: string | string[];
			directClinic?: boolean | boolean[];
			SFHomeDeliveryOnly?: boolean | boolean[];
			altID?: string | string[];
			soldTo?: string | string[];
			country: string | string[];
			payer?: string | string[];
			salesTerritory?: string | string[];
			clinicName2?: string | string[];
			customerClass?: string | string[];
			billingZip?: string | string[];
			customerPriceProcedure?: string | string[];
			accountType?: string | string[];
			paymentTerm?: string | string[];
			companyCode?: string | string[];
			state: string | string[];
		};
	};
};
